<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Holiday Details</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="3" md="3">
                        <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list"
                            item-text="ay" item-value="id" label="Academic Year" outlined persistent-hint
                            hint="Please Select Academic Year" />
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <p>
                            <v-icon color="error">*</v-icon><b class="mr-3">Holiday</b> <v-icon @click="dialog = true"
                                :title="'Click here to add new holiday`s'" class="mr-3"
                                color="primary">mdi-plus-circle-outline</v-icon>
                            <v-icon :title="'Click here to get newly added holiday`s'" color="primary" class="mr-2"
                                @click="onLoad()"> mdi-refresh </v-icon>
                        </p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="holiday" :items="holiday_list"
                            item-text="name" item-value="id" label="Holiday" outlined persistent-hint
                            hint="Please Select Holiday" />
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <p><v-icon color="error">*</v-icon><b>From Date</b></p>
                        <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
                            transition="scale-transition" offset-y max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-bind="attrs" dense v-model="date_of_generation"
                                    @blur="date = parseDate(date_of_generation)" v-on="on" hint="From Date(Inclusive)"
                                    prepend-icon="event" outlined rounded persistent-hint></v-text-field>
                            </template>
                            <v-date-picker v-model="gen_date" no-title @input="menu1 = false"></v-date-picker>
                        </v-menu>
                    </v-col>

                    <v-col cols="12" sm="3" md="3">
                        <p><v-icon color="error">*</v-icon><b>To Date</b></p>
                        <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
                            transition="scale-transition" offset-y max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-bind="attrs" dense v-model="date_of_generation_to"
                                    @blur="date = parseDate(date_of_generation_to)" v-on="on" hint="To Date(Exclusive)"
                                    prepend-icon="event" outlined rounded persistent-hint></v-text-field>
                            </template>
                            <v-date-picker v-model="gen_date_to" no-title @input="menu2 = false"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-4 mt-5" v-if="holiday!=null">
                        <v-btn class="button" @click="saveHolidayDeatils()">Save</v-btn>
                    </v-col>
                </v-row>
                <span v-if="holiday_details_list!=''">
                    <v-data-table v-if="holiday_details_list!=''" dense :headers="headers" :items="bookList1"
                        class="elevation-1 mytable" @current-items="getFiltered">
                        <template v-slot:item.action="{ item }">
                            <div>
                                <v-avatar size="25" class="edit-avatar" @click="editItem(item)">
                                    <v-icon class="mr-2 edit-v-icon" title="edit">edit</v-icon>
                                </v-avatar>
                            </div>
                        </template>
                        <template v-slot:item.isactive="{ item }">
                            <span v-if="item.isactive">
                                <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                            </span>
                            <span v-else>
                                <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                            </span>
                        </template>
                        <template v-slot:top class="pb-5">
                            <v-row justify="center" align="center">
                                <tr class="t-row">
                                    <div>
                                        <th>
                                            <v-row>
                                                <span v-for="header in headers" :key="header.text">
                                                    <span v-if="filters.hasOwnProperty(header.value)">
                                                        <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details small
                                                            rounded dense outlined color="#0F2027" :label="header.text"
                                                            multiple clearable :items="columnValueList(header.value)"
                                                            v-model="filters[header.value]"></v-autocomplete>
                                                    </span>
                                                </span>
                                            </v-row>
                                        </th>
                                    </div>
                                </tr>
                            </v-row>
                        </template>
                    </v-data-table>
                    <v-dialog v-model="dialog_edit" max-width="900px">
                        <v-card>
                            <v-toolbar class="toolbar" flat dense>
                                <v-toolbar-title>Edit Holiday Details</v-toolbar-title>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                            <v-col cols="12" sm="12" md="12">
                                <v-card class="box" v-if="holiday_details_data!=null">
                                    <!-- {{holiday_details_data}} -->
                                    <v-row justify="center" dense>
                                        <v-col cols="12" sm="3" md="3" class="p-0 m-0">
                                            <v-text-field filled readonly rounded outlined dense
                                                v-model="holiday_details_data.academicyear"
                                                label="Academic Year"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="3" md="3" class="p-0 m-0">
                                            <v-text-field filled readonly rounded outlined dense
                                                v-model="holiday_details_data.holiday"
                                                label="Holiday Name"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="3" md="3">
                                            <input id="datePickerId" type="date"
                                                v-model="holiday_details_data.date_edit" />
                                        </v-col>
                                        <v-col cols="12" sm="3" md="3">
                                            <v-checkbox class="pt-1 mt-1" v-model="holiday_details_data.isactive"
                                                color="success" label="Isactive?"></v-checkbox>
                                        </v-col>
                                    </v-row>
                                </v-card>
                                <v-row justify="center">
                                    <v-btn class="button" @click="dialog_edit = false">Cancel</v-btn>
                                    <v-btn class="button" @click="saveHolidayDeatils()">Save</v-btn>
                                </v-row>
                            </v-col>
                        </v-card>
                    </v-dialog>
                </span>
            </v-card>
        </v-container>

        <v-dialog v-model="dialog" fullscreen>
            <v-card>
                <v-col cols="12" sm="12" md="12">
                    <v-card class="box">
                        <holiday></holiday>
                        <v-row justify="center" dense>
                            <v-btn class="button" @click="dialog=false">Cancel</v-btn>
                        </v-row>
                    </v-card>
                </v-col>
            </v-card>
        </v-dialog>
    </div>
    <!-- /. root div -->
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Holiday from "../Admin/Holiday";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
    export default {
        components: {
            holiday: Holiday,
            Breadcrumbs
        },
        data: () => ({
            loader: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            overlay: false,
            sortedbyASC: true,
            search: "",
            search1: "",
            sort_date_wise: false,
            dialog: false,
            selected_date: "",
            radios: null,
            to_date: "",
            date: new Date().toISOString().slice(0, 10),
            menu1: false,
            menu2: false,
            menu11: false,
            todate: null,
            nowDate: new Date().toISOString().slice(0, 10),
            registration_no: "",
            ay_list: [],
            ay: "",
            holiday_list: [],
            holiday: null,
            application_date: "",
            date_of_generation: "",
            // extraBreadcrumbItems: [


            // ],
            // breadcrumbClass: "breadcrumb-style1",
            gen_date: new Date().toISOString().substr(0, 10),

            date_of_generation_to:"",
            gen_date_to: new Date().toISOString().substr(0, 10),

            date_1: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
            modal_1: false,
            date_2: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1).toISOString().substr(0, 10),
            holiday_details_list: [],
            holiday_details_id: null,
            holiday_details_data: null,
            filterArr: [],
            dialog_edit:false,
            filters: {
                academicyear: [],
                holiday: [],
                month: [],
                year: [],
            },
            headers: [
                { text: "Sr.No.", value: "srno", class: "my-header-style" },
                {
                    text: "Holiday Name",
                    value: "holiday",
                    class: "my-header-style",
                },
                {
                    text: "Academic Year",
                    value: "academicyear",
                    class: "my-header-style",
                },
                { text: "Holiday Date", value: "date", class: "my-header-style" },
                { text: "Day", value: "day", class: "my-header-style" },
                { text: "Month", value: "month", class: "my-header-style" },
                { text: "Year", value: "year" ,class: "my-header-style"},
                { text: "Status", value: "isactive" ,class: "my-header-style"},
                { text: "Actions", value: "action", class: "my-header-style"},
            ],
        }),
        watch: {
            gen_date(val) {
                this.date_of_generation = this.formatDate(this.gen_date);
            },
             gen_date_to(val) {
                this.date_of_generation_to = this.formatDate(this.gen_date_to);
            },
        },
        methods: {
            editItem(item){
                this.holiday_details_id = item.id
                this.holiday_details_data = item
                this.dialog_edit = true
            },
            fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
                tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
                tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
                tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
                tab_text = tab_text + "<table border='1px'>";
                var exportTable = $("#" + id).clone();
                exportTable.find("input").each(function (index, elem) {
                    $(elem).remove();
                });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + "</table></body></html>";
                var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

                //Save the file
                // var blob = new Blob([tab_text], {
                //     type: "application/vnd.ms-excel;charset=utf-8",
                // });
                // window.saveAs(blob, fileName);
                const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
       const filename = name+'.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
            },
            saveHolidayDeatils() {
                const data = {
                    date: this.date_of_generation,
                    todate: this.date_of_generation_to,
                    ay: this.ay,
                    holiday: this.holiday,
                    holiday_details_id:this.holiday_details_id,
                    holiday_details_data:this.holiday_details_data
                };
                this.overlay = true;
                axios
                    .post("/EmployeeBiometric/saveHolidayDeatils", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", "Holiday Details Added Successfully");
                            this.onLoad();
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.onerror(error);

                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        this.holiday = null
                        this.dialog_edit = null
                        this.holiday_details_id = null
                        this.holiday_details_data = null
                        this.onLoad();
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            formatDate(date) {
                if (!date) return null;
                const [year, month, day] = date.split("-");
                return `${day}/${month}/${year}`;
            },
            parseDate(date) {
                if (!date) return null;
                const [month, day, year] = date.split("/");
                return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
            },
            onerror(error) {
                let msg = "";
                if (error.response) {
                    msg = "Something went wrong.";
                } else if (error.request) {
                    msg = "Please try again.";
                } else {
                    msg = "Un-expected error.";
                }
                this.showSnackbar("error", msg);
            },
            onLoad() {
                this.overlay = true;
                axios
                    .post("EmployeeBiometric/holidayDetails")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            (this.ay_list = res.data.aylist), (this.ay = res.data.curreny_ay);
                            this.holiday_list = res.data.holiday_list;
                            this.holiday_details_list = res.data.holiday_details_list;
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status_reason);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            getFiltered(e) {
                this.filterArr = e;
            },
            columnValueList(val) {
                return this.holiday_details_list.map((d) => d[val]);
            },
        },
        mounted() {
            this.onLoad();
            this.date_of_generation = this.formatDate(this.gen_date);
            this.date_of_generation_to = this.formatDate(this.gen_date_to);
        },
         computed: {
            bookList1() {
                return this.holiday_details_list.filter((d) => {
                    return Object.keys(this.filters).every((f) => {
                        return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                    });
                });
            },
        },
    };
</script>
<style scoped>
.mytable /deep/ thead th {
    background: #2980b9 !important; /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #2980b9, #2980b9, #2980b9) !important; /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #2980b9, #2980b9, #2980b9) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    background-color: #2980b9 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
}
.v-icon-size {
        font-size: 20px;
}
.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}
.edit-avatar:hover {
    background-color: #b0bec5;
}
.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}
.edit-v-icon:hover {
    color: white;
}
input[type="date"] {
  width: 100%;
  display: inline-block;
  padding: 0.3rem;
  border: 1px solid gray;
  border-radius: 30px;
  box-sizing: border-box;
  padding-top: none !important;
  margin-top: none !important;
}
</style>
